/* eslint no-undefined:0 */
(function(angular) {
    'use strict';
    angular.module('um.commonDirectives')
        .directive('securedInput', function() {
            var WHITELIST = new XRegExp('^[\\p{L}\\p{Nd}|\\s\\n\\r\\-\\.\\+\\(\\)\\[\\]\\|\\/\'&"_,]*$');

            return {
                restrict: 'A',
                require: 'ngModel',
                link: function(scope, ele, attrs, ctrl) {
                    // DOM -> model
                    ctrl.$parsers.unshift(function(value) {
                        var valid = WHITELIST.test(value) || _.isEmpty(value);
                        ctrl.$setValidity('illegalInput', valid);
                        return valid ? value : undefined;
                    });

                    // model -> DOM
                    ctrl.$formatters.unshift(function(value) {
                        var valid = WHITELIST.test(value) || _.isEmpty(value);
                        ctrl.$setValidity('illegalInput', valid);
                        return value;
                    });
                }
            };
        })
        // a different approach
        .directive('securedInputBlacklist', function() {
            var BLACKLIST = /<script|<object|<param|<base|<embed|<frameset|<comment|<form|<button|<input|<body|<math|<maction|<link|<img/;
            return {
                restrict: 'A',
                require: 'ngModel',
                link: function(scope, ele, attrs, ctrl) {
                    ctrl.$parsers.unshift(function(value) {
                        var valid = _.isNull(value.match(BLACKLIST)) || _.isEmpty(value);
                        ctrl.$setValidity('illegalInput', valid);
                        return valid ? value : undefined;
                    });
                }
            };
        });
})(window.angular);
